import { render, staticRenderFns } from "./CarRentalHighlights.vue?vue&type=template&id=5ec62703&scoped=true&"
import script from "./CarRentalHighlights.vue?vue&type=script&lang=js&"
export * from "./CarRentalHighlights.vue?vue&type=script&lang=js&"
import style0 from "./CarRentalHighlights.vue?vue&type=style&index=0&id=5ec62703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec62703",
  null
  
)

export default component.exports